import { InboxOutlined } from "@ant-design/icons";
import { Upload as AntdUpload, UploadProps as AntdUploadProps } from "antd";
import React from "react";
import * as styles from "./Upload.css";

export interface UploadProps extends AntdUploadProps {
  ariaLabel?: string;
  dataTestId?: string;
  supportedFileType?: string;
}

/** Generic Upload Component */
const Upload = ({ ariaLabel, ...props }: UploadProps) => {
  return <AntdUpload aria-labelledby={ariaLabel} {...props} />;
};

/** Dragger Upload Component */
const Dragger = ({ supportedFileType, ...props }: UploadProps) => {
  return (
    <AntdUpload.Dragger {...props}>
      <p className={styles.dragIcon}>
        <InboxOutlined />
      </p>
      <p className={styles.text}>Click or drag file to this area to upload</p>
      {supportedFileType ? (
        <p className={styles.hint}>Expected File Type: {supportedFileType}</p>
      ) : null}
    </AntdUpload.Dragger>
  );
};

Upload.Dragger = Dragger;
Upload.LIST_IGNORE = AntdUpload.LIST_IGNORE;

export default Upload;
